import FilterForm from '../../../components/forms/FilterForm';
import { Col, Form, Input, Row, Space, Table } from 'antd';
import { CrudFilters, HttpError } from '@refinedev/core';
import { EditButton, List, TextField, useTable } from '@refinedev/antd';
import { IGraduateModule } from 'interfaces/graduate_courses';

interface IFilter {
  name: string;
}

export const GraduateModuleList = () => {
  const { tableProps, searchFormProps } = useTable<
    IGraduateModule,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { name } = params;

      filters.push({
        field: 'filter[name]',
        operator: 'eq',
        value: name
      });

      return filters;
    }
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <List>
          <FilterForm searchFormProps={searchFormProps}>
            <Form.Item label="Nome" name="name">
              <Input placeholder="Nome do módulo..." />
            </Form.Item>
          </FilterForm>
          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex="name"
              key="name"
              title="Nome"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="course_name"
              key="course_name"
              title="Nome do curso"
              render={value => <TextField value={value} />}
            />
            <Table.Column<IGraduateModule>
              title="Ações"
              dataIndex="actions"
              render={(_, record) => {
                return (
                  <Space>
                    <EditButton
                      hideText
                      size="small"
                      recordItemId={record.id}
                    />
                  </Space>
                );
              }}
            />
          </Table>
        </List>
      </Col>
    </Row>
  );
};
